import React from "react";
import "./Benefits.css"; // Importing the CSS file

const BenefitsPage = () => {
  return (
    <div className="benefits1-container">
      <h1 className="benefits1-title">Benefits</h1>

      <div className="benefits1-section">
        <h2 className="benefits1-heading">Service Provided</h2>
        <ul className="benefits1-list">
          <li>
            Our prime importance is to be transparent in all our business
            dealings with our clients. Our most equipped labour and wide product
            range enables the customer to get the best product from Pansuriya
            Impex.
          </li>
          <li>
            Therefore hereby we would like to put forward a few benefits that
            every client will achieve when dealing with Pansuriya Impex.
          </li>
          <li>
            <b>++ Delivering the best results in cut, polish, and symmetry.</b>{" "}
            Using the most highly equipped labour and skilled machinery. Our
            consistency in makes, quality material, and well-trained sellers
            create confidence in the client to trust in the name brand Pansuriya
            Impex.
          </li>
          <li>
            <b>++ Market-oriented manufacturing.</b> Our manufacturing unit is
            well aware of the market and the fluctuation of demand in the market
            and can adjust very quickly to deliver the most demanded goods in
            the shortest span of time. Our business is streamlined and due to
            the variety of goods in terms of quality, sizes, colour, and fair
            pricing, all the client requirements can be fulfilled efficiently
            and on time.
          </li>
          <li>
            <b>++ Consistent and competitive pricing.</b> Our fair and simple
            business policies reflect in our prices. Our prices are set after
            intensive market research by our concerned department. The prices
            are stable and easy to understand, ensuring no complications for
            clients.
          </li>
          <li>
            Disclaimer for harm caused by downloads: Visitor downloads
            information from this site at his own risk. Website makes no
            warranty that downloads are free of corrupting computer codes,
            including, but not limited to, viruses and worms. Visitors interact
            with this site or banners at their own risk.
          </li>
        </ul>
      </div>

      {/* Online Benefits Section */}
      <div className="benefits1-section">
        <h2 className="benefits1-heading">Online Benefits</h2>
        <ul className="benefits1-list">
          <li>
            Your complete inventory is maintained on our website where you can
            view, select, and buy in a quick, easy way.
          </li>
          <li>
            At any time, you may select and avail goods as per your specific
            current requirement and operate at a minimum inventory level.
          </li>
          <li>
            Concentrate more on developing your business as purchases can be
            made at comfort and convenience, rather than spending time, energy,
            and money traveling to find the desired goods.
          </li>
          <li>
            All required measurements like crown angle, pavilion depth, girdle
            thickness, diameter, and length-width of all the diamonds are
            provided on our website. With this information, you can visualize
            the stone, and start making your jewellery well before the stone is
            delivered, ensuring prompt onward delivery to your customer.
          </li>
          <li>
            You can download preferred goods from our stock in MS Excel format
            for further transmission to your customers.
          </li>
          <li>
            We provide passwords where you can only view the availability &
            price of the goods desired, while only the authorized password
            (clients) has the right to place an order. This ensures proper
            selection and ordering and helps save a lot of time.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BenefitsPage;
